import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.63915 14.558C7.53057 13.6985 8.73958 13.2156 10.0002 13.2156C11.2609 13.2156 12.4699 13.6985 13.3613 14.558M10.0002 17.5547H10.0089M3.88997 11.6621C7.264 8.40787 12.7364 8.40787 16.1113 11.6621M0.833984 8.71537C5.8959 3.83446 14.1045 3.83446 19.1673 8.71537",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }